/* global window */
import { BasePlugin } from '@uppy/core';

const getFormDataSize = async (fd) => {
  /**
   * A super-convenient way to get the actual Content-Size value before uploading
   */
  const response = new Response(fd);
  const blob = await response.blob();
  return blob.size;
};

const fetchMetadata = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const payloadSize = await getFormDataSize(fd);

  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = window.document.createElement('video');
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(url);
      resolve({
        videoWidth: video.videoWidth,
        videoHeight: video.videoHeight,
        duration: video.duration,
        // Cloudflare reports the size of the content body so we need to know that ahead of time
        // for validation =\
        size: payloadSize,
      });
    };
    video.src = url;
    video.load();
  });
};

class MetadataAdder extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.id = opts.id || 'MetadataAdder';
    this.type = 'preprocessor';
  }

  updateFileMetadata = async (uppyFile) => {
    const metadata = await fetchMetadata(uppyFile.data);
    this.uppy.setFileMeta(uppyFile.id, {
      width: metadata.videoWidth,
      height: metadata.videoHeight,
      duration: Math.round(metadata.duration * 1000), // we want int duration in ms
      fileSize: metadata.size,
    });
  };

  prepareUpload = (fileIds) => {
    const promises = fileIds.map((id) => {
      const file = this.uppy.getFile(id);
      return this.updateFileMetadata(file);
    });
    return Promise.all(promises);
  };

  install() {
    this.uppy.addPreProcessor(this.prepareUpload);
  }

  uninstall() {
    this.uppy.removeUploader(this.upload);
  }
}

export default MetadataAdder;
